export class MedicalAppointmentAudintingSearchItem {
  public IsPendient: boolean;
  public Duration?: number;
  public PlanName: string;
  public Date?: Date;
  public OrderId: number;
  public MedicalAppointmentId: number;
  public DocumentTypeId: number;
  public EntityId: number;
  public EquipmentId: number;
  public CenterId: number;
  public CenterName: string;
  public DateTime: string;
  public EndHour: string;
  public StateName: string;
  public IsOverMedicalAppointment: string;
  public PatientLasNameFirstName: string;
  public Year: number;
  public PatientId: number;
  public PrincipalPracticeName: string;
  public EntityName: string;
  public AssignmentDate: string;
  public Operator: string;
  public EquipmentName: string;
  public PhysicianFullName: string;
  public PersonalPhone: string;
  public LaboralPhone: string;
  public CellPhone: string;
  public Document: string;
  public Observations: string;
  public DocumentNumber?: number;
  public MedicalAppointmentStateId: number;
  public ConfirmationStateName: string;
  public Enabled: boolean;
  public IsChecked: boolean;
  public ConfirmationAccept: string;
  public ConfirmationObservations: string;
  public ConfirmationStateId?: number;
  public LastConfirmationResponseDate?: Date;
  public LastConfirmationResponse: string;
  public IsPatientDataValidated: boolean;
  public IsDocumentationValidated: boolean;
  public IsMedicalRecordValidated: boolean;
  public IsProcedureValidated: boolean;
  public IsReferredToCallCenter: boolean;
}

export enum MedicalAppointmentAudintingType {
  validadoDatoPaciente = 1,
  validadoDocumentacion = 2,
  validadoHce = 3,
  validadoPractica = 4,
  derivadoCallCenter = 5
}
